import api from '../../api/api.js'

import {
	SET_GOODS_LIST,
} from '../mutation-types'

const state = () => ({
	goodslist: [],

})

const getters = {}

const actions = {

	getShopAllItems({
		commit
	}, payload) {

		api
			.getShopAllItems(payload)
			.then(res => {
				if (res.code === 200) {
					console.log(res.data)
					commit(SET_GOODS_LIST, res.data)
				}
			})
	}
}

const mutations = {
	[SET_GOODS_LIST]: (state, data) => {
		state.goodslist = [];
		let index=0;
		data.forEach((item) => {
			if (item.hasVariation) {
				let variations=item.variations;
				variations.forEach((variant)=>{
					state.goodslist.push({
						label: item.name.substring(0,25)+"..."+variant.name,
						key: index++,
						itemId: item.itemId,
						variation: variant.variationId,
					});
				});
			} else {
				state.goodslist.push({
					label: item.name,
					key: index++,
					itemId: item.itemId,
					variation: 0,
				});
			}


		});

	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
